<template>
  <div class="landing">

    <header class="landing-header">
      <div class="container d-flex align-items-center justify-content-between">

        <!-- ESQUERDA -->
        <div class="d-flex align-items-center gap-5">
          <img class="logo" src="/assets/images/logos/logotipo-bg-branco.svg" height="38" />

          <!-- NAV DESKTOP (SÓ DESKTOP GRANDE) -->
          <nav class="d-none d-lg-flex gap-5">
            <a href="#como-funciona">Como funciona</a>
            <a href="#precos">Preços</a>
            <a href="#licenca-estudante">Licença estudantil</a>
          </nav>
        </div>

        <!-- DIREITA DESKTOP -->
        <div class="d-none d-lg-flex align-items-center gap-4">
          <router-link to="/login" class="btn btn-link d-flex align-items-center me-2">
            <img class="me-2" src="../img/user-icon.svg"  />
            Acessar conta
          </router-link>

          <router-link to="/create-account" class="botao-azul">
            Criar minha conta
            <img class="ms-1" src="../img/seta-direta.png" width="14" height="16" />
          </router-link>
        </div>

        <!-- DIREITA MOBILE + TABLET -->
        <div class="d-lg-none">
          <router-link to="/login" class="btn-link btn" style="margin-right: -15px;">
            <img class="me-1" src="../img/user-icon.svg" />
            Acessar conta
          </router-link>
        </div>

      </div>
    </header>

    <!-- HERO -->
    <section class="section-1">
      <div class="container text-center">
        <h1 class="titulo">
          Análise e otimização de vasos de pressão e<br />
          trocadores de calor
        </h1>

        <p class="subtitulo mt-3">
          Uma ferramenta web robusta e intuitiva que alia excelência técnica à praticidade da nuvem para cálculos industriais complexos.
        </p>

        <div class="botoes-meio mt-5 d-flex align-items-center justify-content-center gap-3">
          <router-link to="/create-account" class="botao-azul btn btn-primary">
            Criar minha conta
            <img class="ms-1" src="../img/seta-direta.png" width="14" height="16" />
          </router-link>
          <a href="#como-funciona" class="link-conhecer-claro">
            Conheça a WiseCalc
            <img class="ms-1" src="../img/seta-baixo.png" width="14" height="16" />
          </a>
        </div>

        <!-- MOCKUP -->
        <div class="hero-mockup mt-5">
          <img
            src="../img/app.svg"
            class="img-app img-fluid"
          />
        </div>
      </div>
    </section>

    <!-- LICENCA ESTUDANTIL -->
    <section id="licenca-estudante" class="student-license-section">
      <div class="container">
        <div class="row align-items-center g-5">
          <div class="col-12 col-lg-5">
            <span class="badge-software">Para estudantes</span>
            <h2 class="titulo-licenca mt-3">Estude com a WiseCalc por 1 ano grátis</h2>
            <p class="texto-licenca mt-3">
              Envie seus dados acadêmicos e uma carteirinha válida. Após a conferência,
              liberaremos sua licença estudantil sem custo por 12 meses.
            </p>
            <p class="texto-privacidade mb-0">Seus documentos serão usados somente para validar a solicitação.</p>
          </div>

          <div class="col-12 col-lg-7">
            <form class="student-license-form" @submit.prevent="solicitarLicenca" enctype="multipart/form-data">
              <div v-if="mensagemFormulario" :class="['form-feedback', sucessoFormulario ? 'form-feedback--success' : 'form-feedback--error']" role="status">
                {{ mensagemFormulario }}
              </div>

              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label for="nome-estudante">Nome completo *</label>
                  <input id="nome-estudante" v-model.trim="formulario.nome" type="text" required autocomplete="name" />
                </div>
                <div class="col-12 col-md-6">
                  <label for="cpf-estudante">CPF *</label>
                  <input id="cpf-estudante" v-model.trim="formulario.cpf" @input="formulario.cpf = formatarCpf(formulario.cpf)" type="text" required inputmode="numeric" maxlength="14" placeholder="000.000.000-00" autocomplete="off" />
                </div>
                <div class="col-12 col-md-6">
                  <label for="email-estudante">E-mail *</label>
                  <input id="email-estudante" v-model.trim="formulario.email" type="email" required autocomplete="email" />
                </div>
                <div class="col-12 col-md-6">
                  <label for="universidade-estudante">Universidade *</label>
                  <input id="universidade-estudante" v-model.trim="formulario.universidade" type="text" required />
                </div>
                <div class="col-12 col-md-6">
                  <label for="curso-estudante">Curso *</label>
                  <input id="curso-estudante" v-model.trim="formulario.curso" type="text" required />
                </div>
                <div class="col-12">
                  <label for="carteirinha-estudante">Carteirinha de estudante *</label>
                  <input id="carteirinha-estudante" type="file" accept="image/jpeg,image/png,application/pdf" required @change="selecionarCarteirinha" />
                  <small>JPG, PNG ou PDF, até 5 MB.</small>
                </div>
              </div>

              <button type="submit" class="botao-azul mt-4" :disabled="enviandoFormulario">
                {{ enviandoFormulario ? 'Enviando solicitação...' : 'Solicitar licença gratuita' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- CALCULADORAS PCC2 -->
    <section class="pcc2-section">
      <div class="container">
        <div class="pcc2-content">
          <span class="badge-software">Em breve</span>
          <h2 class="titulo mt-3">Calculadoras de PCC2</h2>
          <p class="mt-3 mb-0">
            Em breve, a WiseCalc também contará com calculadoras baseadas no PCC2,
            ampliando as possibilidades de análise e dimensionamento para seus projetos.
          </p>
        </div>
      </div>
    </section>

    <!-- SECTION 02 -->
    <section class="section-2">
      <div class="container">
        <div class="row align-items-center">

          <!-- TEXTO -->
          <div class="col-12 col-lg-6 mb-5 mb-lg-0">
            <span class="badge-software">Conheça nosso software</span>

            <h2 class="titulo mt-3">
              Automatize o projeto de seus<br />
              recipientes e trocadores de calor
            </h2>

            <p class="mt-3">
              Lorem ipsum dolor sit amet consectetur. Morbi non pulvinar non
              integer fringilla cras. A ac auctor fermentum quis. Netus ultrices
              cras sit at adipiscing purus. In cursus arcu mi sed enim morbi
              tellus quis sed. Iaculis cras laoreet nulla.
            </p>

            <div class="botoes-meio mt-4 d-flex align-items-center gap-4">
              <router-link to="/create-account" class="botao-azul btn btn-primary">
                Criar minha conta
                <img class="ms-1" src="../img/seta-direta.png" width="14" height="16" />
              </router-link>

              <a href="#como-funciona" class="link-conhecer">
                Conheça a WiseCalc
                <img class="ms-1" src="../img/seta-baixo-1.png" width="14" height="16" />
              </a>
            </div>
          </div>

          <!-- IMAGEM -->
          <div class="col-12 col-lg-6 text-center">
            <div class="imagem-mulher">
              <img
                src="../img/mulher.png"
                alt="Usuária utilizando o WiseCalc"
                class="img-fluid"
              />
            </div>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      formulario: { nome: '', cpf: '', email: '', universidade: '', curso: '', carteirinha: null },
      enviandoFormulario: false,
      mensagemFormulario: '',
      sucessoFormulario: false
    };
  },
  methods: {
    selecionarCarteirinha(event) {
      this.formulario.carteirinha = event.target.files[0] || null;
    },
    formatarCpf(valor) {
      const cpf = valor.replace(/\D/g, '').slice(0, 11);
      return cpf
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    },
    async solicitarLicenca() {
      this.mensagemFormulario = '';
      this.sucessoFormulario = false;

      const cpf = this.formulario.cpf.replace(/\D/g, '');
      if (cpf.length !== 11) {
        this.mensagemFormulario = 'Informe um CPF válido.';
        return;
      }

      if (!this.formulario.carteirinha || this.formulario.carteirinha.size > 5 * 1024 * 1024) {
        this.mensagemFormulario = 'Selecione uma carteirinha válida de até 5 MB.';
        return;
      }

      const dados = new FormData();
      Object.entries({ ...this.formulario, cpf }).forEach(([campo, valor]) => dados.append(campo, valor));
      this.enviandoFormulario = true;

      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/solicitar-licenca-estudante`, { method: 'POST', body: dados });
        const resultado = await resposta.json();
        if (!resposta.ok) throw new Error(resultado.message || 'Não foi possível enviar sua solicitação.');

        this.sucessoFormulario = true;
        this.mensagemFormulario = 'Solicitação enviada. Enviaremos a confirmação para seu e-mail após a validação.';
        this.formulario = { nome: '', cpf: '', email: '', universidade: '', curso: '', carteirinha: null };
        this.$el.querySelector('#carteirinha-estudante').value = '';
      } catch (error) {
        this.mensagemFormulario = error.message;
      } finally {
        this.enviandoFormulario = false;
      }
    }
  }
};
</script>

<style scoped>
.landing {
  font-family: "Manrope", system-ui, sans-serif;
}

/* HEADER */
.landing-header {
  background: #ffffff;
  padding: 16px 0;
  border-bottom: 1px solid #edf0f5;
}

/* HERO */
.titulo{
  color: white;
}

.section-1 {
  /* background: linear-gradient(135deg, #061833, #0b2b5e); */
  background: #001232;
  color: #fff;
  padding: 100px 0 120px;
  height: 850px;
  position: relative;
  overflow: hidden;
  padding-bottom: 360px;
}

.section-1::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("../img/fundo-blocos.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  z-index: 0;
}

.section-1 h1 {
  font-size: 42px;
  font-weight: 800;
  line-height: 1.2;
}

.section-1 p {
  max-width: 760px;
  margin: 0 auto;
  opacity: 0.9;
  font-size: 18px;
}

.hero-mockup {
  position: absolute;
  left: 50%;
  /* bottom: 0; */
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  justify-content: center;
}

/* BOTÕES */
.botao-outline {
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
  border: none;
  color: white;
}

.botao-outline:hover {
  color: white;
  background-color: #0056ff;
  border: none;
}

.botao-azul {
  color: white;
  background-color: #0056ff;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
}

.btn-link, a{
  color: #0b1c2d;
  font-weight: 600;
  text-decoration: none;
}

.landing-arrow {
  filter:
    drop-shadow(0.10px 0 currentColor)
    drop-shadow(-0.10px 0 currentColor)
    drop-shadow(0 0.10px currentColor)
    drop-shadow(0 -0.10px currentColor);
}

/* SECTION 02 */
.section-2 {
  background-color: #ffffff;
  padding: 120px 0;
}

.section-2 h2 {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.25;
  color: #0b1c2d;
}

.section-2 p {
  color: #5b6b82;
  font-size: 16px;
  line-height: 1.7;
  max-width: 520px;
}

.student-license-section { background: #f4f7fb; padding: 100px 0; }
.titulo-licenca { color: #0b1c2d; font-size: 36px; font-weight: 800; line-height: 1.2; }
.texto-licenca, .texto-privacidade { color: #5b6b82; line-height: 1.7; }
.texto-privacidade { font-size: 13px; }
.pcc2-section { background: #0b1c2d; padding: 88px 0; }
.pcc2-content { margin: 0 auto; max-width: 720px; text-align: center; }
.pcc2-content h2 { color: #ffffff; font-size: 36px; font-weight: 800; line-height: 1.2; }
.pcc2-content p { color: #d7e2f0; font-size: 16px; line-height: 1.7; margin-left: auto; margin-right: auto; max-width: 620px; }
.pcc2-content .badge-software { background: #eaf2ff; }
.student-license-form { background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 32px; box-shadow: 0 16px 40px rgba(11, 28, 45, 0.08); }
.student-license-form label { color: #0b1c2d; display: block; font-size: 14px; font-weight: 700; margin-bottom: 8px; }
.student-license-form input { border: 1px solid #d4dce8; border-radius: 6px; color: #0b1c2d; padding: 11px 12px; width: 100%; }
.student-license-form input:focus { border-color: #0056ff; outline: 3px solid rgba(0, 86, 255, 0.12); }
.student-license-form small { color: #6c7a8d; display: block; margin-top: 6px; }
.student-license-form button:disabled { cursor: wait; opacity: 0.7; }
.form-feedback { border-radius: 6px; font-size: 14px; margin-bottom: 20px; padding: 12px 14px; }
.form-feedback--success { background: #e9f8ef; color: #176b38; }
.form-feedback--error { background: #fff0f0; color: #a32929; }

/* Badge */
.badge-software {
  display: inline-block;
  background: #eef5ff;
  color: #0056ff;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 20px;
}

/* Link */
.link-conhecer-claro {
  color: white;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
  text-decoration: none;
}

.link-conhece-escuro {
  color: #0b1c2d;
  font-weight: 600;
  text-decoration: none;
}

.link-conhecer-claro:hover,
.link-conhece-escuro:hover {
  text-decoration: underline;
}

/* Imagem */

.img-app{
  width: 1400px;
}

.imagem-mulher {
  position: relative;
  display: inline-block;
}

.imagem-mulher::before {
  content: "";
  position: absolute;
  inset: -30px;
  border-radius: 24px;
  z-index: 0;
}

.imagem-mulher img {
  position: relative;
  z-index: 1;
  border-radius: 16px;
  max-height: 420px;
  width: 150%;
}

.section-1 > .container {
  position: relative;
  z-index: 1;
}

.botoes-meio {
  position: relative;
  z-index: 2;
}

/* RESPONSIVIDADE */

/* MOBILE */
@media (max-width: 768px) {
  .logo{
    height: 32px;
  }

  .titulo {
    font-size: 28px !important;
    line-height: 1.25;
  }

  .subtitulo {
    font-size: 32px !important;
    line-height: 1.25;
  }

  .section-1 {
    padding-bottom: 260px;
    height: 600px !important;
  }

  .hero-mockup {
    position: relative; /* volta ao fluxo */
    transform: none;
    left: auto;
  }

  .hero-mockup img {
    max-width: 100%;
  }

  .section-1, .section-2{
    padding: 60px 20px;
  }

  .student-license-section { padding: 60px 20px; }
  .pcc2-section { padding: 64px 20px; }
  .pcc2-content h2 { font-size: 30px; }
  .student-license-form { padding: 22px; }
  .titulo-licenca { font-size: 30px; }

  /* MENU CELULAR */
  .landing-header {
    padding: 20px 20px;
  }

  .botoes-meio {
    flex-direction: column;
    align-items: center;
  }

  .botoes-meio a,
  .botoes-meio .btn {
    width: 100%;
    max-width: 320px; /* opcional, fica bonito */
    text-align: center;
  }

  /* Imagem do app */
  @media (max-width: 768px) {
  .hero-mockup img {
    content: url("../img/app-mobile.svg");
    margin-right: -65px;
    margin-top: -30px;
  }
}


}

/* TABLET */
@media (max-width: 1024px) {
  .titulo {
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  }

  .subtitulo {
    font-size: 16px !important;
    max-width: 920px;
    margin-left: auto;
    margin-right: auto;
  }

  .botoes-meio {
    margin-top: 0px;
    margin-bottom: 0px !important;
  }

  .section-1 {
    padding-bottom: 300px;
    height: 720px;
  }

  .section-2 {
    padding-top: 75px;
  }

  .img-app{
    max-width: 800px;
  }

}
</style>
